export default __webpack_public_path__ + "static/media/maxBonusAmountIcon.b9ed0950.svg";